import cx from 'classnames';
import React, { ReactNode } from 'react';

import { DefaultIllustration } from './default-illustration';

export const ErrorMessage = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cx(
        'flex flex-col items-center justify-center gap-4',
        className,
      )}
    >
      <DefaultIllustration />
      {children}
    </div>
  );
};

export const ErrorMessageTitle = ({ children }: { children: ReactNode }) => {
  return (
    <h1 className="my-6 p-0 no-underline font-semibold text-3xl">{children}</h1>
  );
};
